import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  height: 100%;
  overflow: hidden;
`;
